import { DAY_NUMBER } from "@utils/enums";
import { Week } from "../context/linkData.reducer";
import { BlockRanges, EditedSession } from "../context/formData.reducer";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const isOutsideThreshold = (threshold: string | null, week: Week, blocks: BlockRanges) => {
  if (!threshold || !week?.id) return false;

  const [thresholdDate, thresholdTime] = (threshold ?? "").split(" ");

  if (blocks?.selected === "hours") {
    const [hour, minutes] = thresholdTime?.split(":");
    const time = `${hour}:${minutes}:00`;
    const todayDayNum = dayjs().day();
    const dayNum = blocks?.day ? DAY_NUMBER?.[blocks?.day] : todayDayNum;
    const sessionDate = dayjs(week?.startingDate)
      .add(dayNum - 1, "day")
      .format("YYYY-MM-DD");

    return (
      sessionDate < thresholdDate || (sessionDate === thresholdDate && time >= blocks?.startTime)
    );
  }

  return week?.startingDate <= thresholdDate || week?.endingDate <= thresholdDate;
};

/**
 * Session-aware threshold classification used by every per-session fork flow.
 * Aggregate multi-edit blocks may omit the day, so they are not a valid input
 * when deciding which persisted session owns a week after the split.
 */
export const isSessionWeekOutsideThreshold = (
  threshold: string | null,
  week: Week,
  session: EditedSession,
): boolean => isOutsideThreshold(threshold, week, session?.blocks);
